export default __webpack_public_path__ + "locales/lo-LA/EmptyView.json?hash=8f71f4825d518c645b5433e5433ad96e";